import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

const VideoEmbed = ({ video, className }) => {
  const customClassName = classNames('video-embed', className);
  return (
    <div className={customClassName}>
      <iframe
        title={video}
        src={`https://player.vimeo.com/video/${video}?byline=false&title=false`}
        frameBorder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen
      />
    </div>
  );
};

VideoEmbed.propTypes = {
  video: PropTypes.string,
  className: PropTypes.string,
};

VideoEmbed.defaultProps = {
  video: '472725102',
  className: null,
};

export default VideoEmbed;
